import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Marquee } from "@/components/shared/Marquee";
import { Hero } from "@/components/sections/Hero";
import { PromoVideo } from "@/components/sections/PromoVideo";
import { MarketplaceMap } from "@/components/sections/MarketplaceMap";
import { WhereWereLaunching } from "@/components/sections/WhereWereLaunching";
import { Testimonials } from "@/components/sections/Testimonials";
import { Problem } from "@/components/sections/Problem";
import { HowItWorks } from "@/components/sections/HowItWorks";
import { OpportunityTypes } from "@/components/sections/OpportunityTypes";
import { Drivers } from "@/components/sections/Drivers";
import { DriverRequirements } from "@/components/sections/DriverRequirements";
import { FoundingDriverProgram } from "@/components/sections/FoundingDriverProgram";
import { LaunchBanner } from "@/components/sections/LaunchBanner";
import { TopReferrers } from "@/components/sections/TopReferrers";
import { OwnerOperators } from "@/components/sections/OwnerOperators";
import { FindADriver } from "@/components/sections/FindADriver";
import { HOSRelief } from "@/components/sections/HOSRelief";
import { RelayHandoff } from "@/components/sections/RelayHandoff";
import { Carriers } from "@/components/sections/Carriers";
import { CarrierEarlyAccess } from "@/components/sections/CarrierEarlyAccess";
import { NavigationSection } from "@/components/sections/Navigation";
import { ELDIntegration } from "@/components/sections/ELDIntegration";
import { RVRescue } from "@/components/sections/RVRescue";
import { PaymentTrust } from "@/components/sections/PaymentTrust";
import { SafetyTrust } from "@/components/sections/SafetyTrust";
import { AntiFraud } from "@/components/sections/AntiFraud";
import { AssignmentTimeline } from "@/components/sections/AssignmentTimeline";
import { WhoItsFor } from "@/components/sections/WhoItsFor";
import { MobileApp } from "@/components/sections/MobileApp";
import { AppShowcase } from "@/components/sections/AppShowcase";
import { VideoGallery } from "@/components/sections/VideoGallery";
import { About } from "@/components/sections/About";
import { Pricing } from "@/components/sections/Pricing";
import { FAQ } from "@/components/sections/FAQ";
import { useAnalyticsSectionTracking } from "@/hooks/useAnalyticsSectionTracking";
import { LiveSignupFeed } from "@/components/shared/LiveSignupFeed";
import { ReferralWinWatcher } from "@/components/shared/ReferralWinWatcher";
import { AmbassadorBadge } from "@/components/shared/AmbassadorBadge";

export default function Landing() {
  useAnalyticsSectionTracking();
  return (
    <div data-testid="landing-page">
      <LiveSignupFeed />
      <ReferralWinWatcher />
      <AmbassadorBadge />
      <Header />
      <Hero />
      <PromoVideo />
      <LaunchBanner />
      <MarketplaceMap />
      <WhereWereLaunching />
      <Testimonials />
      <Problem />
      <HowItWorks />
      <OpportunityTypes />
      <Drivers />
      <DriverRequirements />
      <FoundingDriverProgram />
      <TopReferrers />
      <OwnerOperators />
      <FindADriver />
      <HOSRelief />
      <RelayHandoff />
      <Marquee text="KEEP THE TRIP MOVING" />
      <Carriers />
      <CarrierEarlyAccess />
      <NavigationSection />
      <ELDIntegration />
      <RVRescue />
      <PaymentTrust />
      <SafetyTrust />
      <AntiFraud />
      <AssignmentTimeline />
      <WhoItsFor />
      <MobileApp />
      <AppShowcase />
      <VideoGallery />
      <About />
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  );
}
